import { getFunction } from './getFunction.ts';
import { getSignupRef } from '../openpanel/getSignupRef.ts';

/**
 * Calls the `onAppStart` cloud function with the name of the current app, so the server can record where a new user
 * signed up, and the page-load signup reference, so the server's signup event can be paired with the browser's
 * (left out when the browser cannot make one).
 * Use this instead of calling `getFunction('onAppStart')` directly.
 */
export const callOnAppStart = () => {
    const signupRef = getSignupRef();
    return getFunction('onAppStart')({ appName: process.env.PUBLIC_APP_NAME, ...(signupRef ? { signupRef } : {}) });
};
